import { ReactElement } from 'react';
import clsx from 'clsx';

import checkImg1x from '../../../assets/images/check@1x.png';
import checkImg2x from '../../../assets/images/check@2x.png';

import styles from './styles.module.scss';

export interface ImageProps {
  imageProps?: Pick<HTMLImageElement, 'src' | 'srcset'>;
  imageSize?: 'small' | 'medium' | 'large';
}

export function Image({
  imageProps,
  imageSize = 'medium',
}: ImageProps): ReactElement {
  const className = clsx(styles[imageSize], styles.img);

  return (
    <img
      src={imageProps?.src || checkImg1x}
      srcSet={imageProps?.srcset || `${checkImg2x} 2x`}
      className={className}
    />
  );
}
